/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_UnauthorizedInputs */

const en_error_unauthorized = /** @type {(inputs: Error_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You don't have permission to do this.`)
};

const es_error_unauthorized = /** @type {(inputs: Error_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tienes permiso para hacer esto.`)
};

const fr_error_unauthorized = /** @type {(inputs: Error_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous n'avez pas l'autorisation de faire cela.`)
};

const de_error_unauthorized = /** @type {(inputs: Error_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast nicht die Berechtigung, dies zu tun.`)
};

const ja_error_unauthorized = /** @type {(inputs: Error_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この操作を実行する権限がありません。`)
};

const zh_error_unauthorized = /** @type {(inputs: Error_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您没有执行此操作的权限。`)
};

const ar_error_unauthorized = /** @type {(inputs: Error_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ليس لديك صلاحية للقيام بذلك.`)
};

const id_error_unauthorized = /** @type {(inputs: Error_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda tidak memiliki izin untuk melakukan ini.`)
};

const it_error_unauthorized = /** @type {(inputs: Error_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non hai i permessi per eseguire questa azione.`)
};

const ru_error_unauthorized = /** @type {(inputs: Error_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У вас нет прав для выполнения этого действия.`)
};

const pt_error_unauthorized = /** @type {(inputs: Error_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você não tem permissão para fazer isso.`)
};

const ko_error_unauthorized = /** @type {(inputs: Error_UnauthorizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 작업을 수행할 권한이 없습니다.`)
};

/**
* | output |
* | --- |
* | "You don't have permission to do this." |
*
* @param {Error_UnauthorizedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_unauthorized = /** @type {((inputs?: Error_UnauthorizedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_UnauthorizedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_unauthorized(inputs)
	if (locale === "es") return es_error_unauthorized(inputs)
	if (locale === "fr") return fr_error_unauthorized(inputs)
	if (locale === "de") return de_error_unauthorized(inputs)
	if (locale === "ja") return ja_error_unauthorized(inputs)
	if (locale === "zh") return zh_error_unauthorized(inputs)
	if (locale === "ar") return ar_error_unauthorized(inputs)
	if (locale === "id") return id_error_unauthorized(inputs)
	if (locale === "it") return it_error_unauthorized(inputs)
	if (locale === "ru") return ru_error_unauthorized(inputs)
	if (locale === "pt") return pt_error_unauthorized(inputs)
	return ko_error_unauthorized(inputs)
});